/**
 * Route definitions for the Quotes module.
 * Lazily loads page components for quotes list and quote creation.
 */
import createFeatureRoutes from '@/common/presentation/components/MainRouteHelper/MainRouteHelper';

const QuotesRoutes = createFeatureRoutes(
  'quotes',
  {
    list: () => import('@/quotes/presentation/pages/QuotesManagementPage'),
    create: () => import('@/quotes/presentation/pages/NewQuotePage')
  },
  [
    { path: '', pageKey: 'list' }, // Default route shows list page
    { path: 'create', pageKey: 'create' }
  ]
);

export default QuotesRoutes;
